var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { ArtActionHeading } from "./Heading";
import { artActionDetailsCls, artActionDimentionsCls, artActionHintWrapperCls } from "./Action.less";
var ArtActionDetails = /* @__PURE__ */ __name(function ArtActionDetails2(props) {
  var title = props.title, artistUrl = props.artistUrl, artistName = props.artistName, additionalText = props.additionalText, dimensions = props.dimensions, Hint = props.hint, links = props.links, translations = props.translations, children = props.children;
  var hintText = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, translations.artworkSizeTooltipHeading), /* @__PURE__ */ React.createElement("p", null, translations.artworkSizeTooltipDescription));
  return /* @__PURE__ */ React.createElement("div", {
    className: artActionDetailsCls
  }, /* @__PURE__ */ React.createElement(ArtActionHeading, {
    title,
    artistUrl,
    artistName,
    translations,
    links
  }), /* @__PURE__ */ React.createElement("div", {
    className: artActionDimentionsCls
  }, additionalText ? /* @__PURE__ */ React.createElement("span", null, additionalText) : null, /* @__PURE__ */ React.createElement("span", null, dimensions), /* @__PURE__ */ React.createElement("span", {
    className: artActionHintWrapperCls
  }, /* @__PURE__ */ React.createElement(Hint, {
    type: "hint",
    padded: true,
    wrapperTag: "span",
    showOnClick: true,
    placement: "N",
    text: hintText
  }))), children || null);
}, "ArtActionDetails");
export {
  ArtActionDetails
};
